import { connect } from '@vfde-fe/sails_core';
import { createStructuredSelector } from 'reselect';
import mountOptionTabs, { updateOptionTab } from '../../components/optionTabs';
import { selectOption } from '../App/action';
import { selectError, selectSalesChannel, selectSelectedOption, selectTariff } from 'Container/App/selector';
import { mountJustText } from '../../components/justText';
import { isFlexId } from '../../helper/additionalPageOptionsHelper';
import { areIdsNotEqual } from '../../helper/validator';
import updateTariffBenefits from '../../components/verticalList';
import { HtmlId } from '../App/enum';
import { SalesChannel } from '../../enum';

const mapDispatch = {
    selectOption,
};

const mapStateToProps = createStructuredSelector({
    salesChannel: selectSalesChannel,
    selectedOption: selectSelectedOption,
    tariff: selectTariff,
    error: selectError,
});

type State = ReturnType<typeof mapStateToProps>;
type Actions = typeof mapDispatch;

/**
 * TariffSelection function
 */
function TariffSelection (state: State, actions: Actions) {
    const flexTariffHintComp = mountJustText(HtmlId.FLEX_HINT);
    const youngHintComp = mountJustText(HtmlId.YOUNG_HINT);
    const optionTabs = mountOptionTabs(HtmlId.TARIFF_SELECTION, actions.selectOption);

    return {
        getDerivedStateFromProps ({ error, tariff, selectedOption, salesChannel }: State, oldState: State) {
            if (error) {
                return;
            }

            const { hardwareId, subscriptionId } = selectedOption;
            const { hardwareId: oldHardwareId } = oldState.selectedOption;

            const isFlex = isFlexId(subscriptionId);
            const hardwareChanged = areIdsNotEqual(hardwareId, oldHardwareId);
            const didSelectedOptionChanged = selectedOption !== oldState.selectedOption;
            const didHardwareObjectChanged = tariff?.hardware !== oldState.tariff?.hardware;
            const salesChanged = salesChannel !== oldState.salesChannel;
            const didUpdateOptionTab = selectedOption?.subscription && (hardwareChanged || salesChanged || didHardwareObjectChanged);

            salesChannel === SalesChannel.YOUNG
                ? youngHintComp?.showContainer()
                : youngHintComp?.hideContainer();

            isFlex
                ? flexTariffHintComp?.showContainer()
                : flexTariffHintComp?.hideContainer();

            didSelectedOptionChanged && updateTariffBenefits(subscriptionId);
            didUpdateOptionTab && updateOptionTab(optionTabs, tariff.tariffs, subscriptionId);
        },
    };
}

const tariffSelection = connect(mapStateToProps, mapDispatch)(TariffSelection);

export default tariffSelection;
